import {
  getOptionLabel,
  renderPrice,
  termOptions,
} from "../../../utils/Common";
export const LicenseItemsColumns = () => {
  return [
    {
      title: "No",
      dataIndex: "ItemNo",
      key: "ItemNo",
    },
    {
      title: "Item",
      dataIndex: "ItemName",
      key: "ItemName",
    },
    {
      title: "Code",
      dataIndex: "CodeName",
      key: "CodeName",
    },
    {
      title: "Term",
      dataIndex: "Term",
      key: "Term",
      render: (value) => getOptionLabel(termOptions, value),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: renderPrice,
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
